import * as React from 'react';

function NoPainIcon(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
        fill="#30AE7A"
      />
      <path
        d="M15.57 22.824c-.073 0-.132.119-.13.261.07 4.878 2.088 8.791 4.568 8.791 2.48 0 4.498-3.913 4.568-8.79.002-.143-.057-.262-.13-.262H15.57Z"
        fill="#2B2523"
      />
      <path
        d="M22.642 30.215c-.746 1.045-1.654 1.659-2.636 1.659-1.04 0-1.996-.687-2.764-1.842 0 0 1.061-.779 2.755-.682 1.83.102 2.645.865 2.645.865Z"
        fill="#EA6959"
      />
      <path
        d="m24.64 22.86-.132 1.518h-9s-.044-.468-.052-.624c-.013-.245-.03-.924-.03-.924 0-.019.017-.035.035-.035l9.144.027c.019 0 .035.016.035.038Z"
        fill="#fff"
      />
      <path
        d="M16.128 19.098a.81.81 0 0 1-.779-.592c-.299-1.075-.88-1.533-1.947-1.533-1.223 0-1.796.954-1.945 1.52a.812.812 0 0 1-.985.578.812.812 0 0 1-.58-.985c.343-1.315 1.587-2.729 3.51-2.729 1.799 0 3.011.94 3.504 2.715a.807.807 0 0 1-.563.994.731.731 0 0 1-.215.032ZM29.324 19.098a.81.81 0 0 1-.779-.592c-.299-1.075-.88-1.533-1.947-1.533-1.223 0-1.796.954-1.944 1.52a.81.81 0 0 1-.986.578.812.812 0 0 1-.58-.985c.343-1.315 1.587-2.729 3.51-2.729 1.8 0 3.011.94 3.504 2.715a.807.807 0 0 1-.563.994.73.73 0 0 1-.215.032Z"
        fill="#2B2523"
      />
    </svg>
  );
}

export default NoPainIcon;
